module.exports = __webpack_public_path__ + "img/hover-iocn4.679c53fb.svg";